import React from 'react';

export {
  IconAlert, IconBook, IconHedge, IconLock, IconZap, IconCheck, IconChevronLeft, IconChevronRight,
} from '../Icons';

export const IconArrowRight = ({ size = 14, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" className="wo-arrow" aria-hidden="true">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);
